/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 案件詳細資料頁面
 * @module CaseDetailContainer
 */

// ----- import from local libraries -----
import {useState} from 'react';
import {React} from '../../components/BaseComponent';
// ----- import from local components -----
import Footer from '../../features/main-frame/components/Footer';
import Header from '../../features/main-frame/components/Header';
import Sidebar from '../../features/main-frame/components/Sidebar';

import {useSelector} from 'react-redux';
import CoordinatesModal from '../case-apply/components/CoordinatesModal';
import CaseDetailPage from './CaseDetailPage';
import {useParams} from 'react-router';

// ----- constants and enums -----

const CaseDetailContainer = (props) => {
  const userPermissions =
    useSelector((state) => JSON.parse(state.access.userPermissions));
  const {id: caseNumber} = useParams();

  const [isOpen, setIsOpen] = useState(false);
  // 紀錄詳細的單一用戶資料
  const [selectedCustomerData, setSelectedCustomerData] = useState(null);

  const onOpenChange = (isOpenStatus)=>setIsOpen(isOpenStatus);

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <CaseDetailPage
            {...props}
            userPermissions={userPermissions}
            setSelectedCustomerData={(data) => setSelectedCustomerData(data)}
            onOpenChange={onOpenChange}
            caseNumber={caseNumber}
          />
        </div>
        <Footer />
        <CoordinatesModal
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          selectedCustomerData={selectedCustomerData}
        />
      </div>
    </>
  );
};

export default CaseDetailContainer;
